import React, { useContext } from 'react';
import { Icon, Label } from '@nooz-optics/nooz-components-lib';
import { CheckoutContext } from '../../../../../../utils/providers/checkout';
import { CartContext } from '../../../../../../utils/providers/cart';
import { Cart } from '../../../../../Ecommerce/Cart/cart';
import { CartFooter } from '../../../../../Ecommerce/Cart/Footer/cartFooter';
import { Button } from '../../../../Elements';
import { formatContentfulComponentProps } from '../../../../../../utils/globals';
import { useDrawer } from '../../../../../../utils/recoil/drawer';

export const HeaderActionCart = () => {
  const drawer = useDrawer();

  const { checkout, loading } = useContext(CheckoutContext);

  const cart = useContext(CartContext);
  // @ts-ignore
  const body = formatContentfulComponentProps(cart.body);
  // @ts-ignore
  const footer = formatContentfulComponentProps(cart.footer);

  const returnQuantity = () => {
    if (checkout && checkout[0] && checkout[0].lineItems?.length > 0) {
      let totalQuantity = 0;
      const packLineOrderList = [];
      // check each line item quantity (packs)
      checkout[0].lineItems.forEach((lineItem) => {
        // HANDLE PACKS QUANTITY SUMMARY
        // get line item pack attributes
        const packAttr = lineItem.customAttributes.find(
          (attr) => attr.key === 'pack'
        );
        // has a pack attribute
        if (packAttr) {
          // get pack id
          const existingPack = packLineOrderList.find(
            (pack) => pack === packAttr.value
          );
          // pack id not found
          if (!existingPack) {
            totalQuantity += 1;
            packLineOrderList.push(packAttr.value);
          }
        } else {
          totalQuantity += lineItem.quantity;
        }
      });
      return totalQuantity.toString();
    } else {
      return '0';
    }
  };

  const quantity = returnQuantity();

  const returnButtonLabel = () => (
    <div className='flex items-center'>
      <div className='mr-1'>
        <Icon
          iconKey='HiOutlineShoppingCart'
          color={{ classname: 'white' }}
          size='xl'
        />
      </div>
      {quantity && (
        <>
          <span>|</span>
          <div className='ml-1'>
            <Label
              type='span'
              weight='bold'
              text={quantity}
            />
          </div>
        </>
      )}
    </div>
  );

  const handleOnclick = () => {
    drawer.open({
      // @ts-ignore
      ...cart,
      placement: 'right',
      footer: (
        <CartFooter
          body={body}
          footer={footer}
        />
      ),
      // @ts-ignore
      body: (
        <Cart
          body={body}
          promotion={cart.promotion}
        />
      ),
      width: 'lg:w-screen/2 sm:w-screen-2/3 w-screen-95',
    });
  };

  return (
    <Button
      disabled={loading && loading[0]}
      onClick={handleOnclick}
      size='base'
      color={{ classname: 'primary' }}
      type='contained'>
      {returnButtonLabel()}
    </Button>
  );
};
